export default {
  state: {
    detail: null,
    urlQuery: null,
    selectedLeaveList: null,
    leaveQueueIndex: 0
  },
  mutations: {
    setLeaveDetail(state, payload) {
      state.detail = payload
    },
    setLeavePageQuery(state, payload) {
      state.urlQuery = payload
    },
    setLeaveQueue(state, payload) {
      state.selectedLeaveList = payload.list
      state.leaveQueueIndex = payload.index
    }
  },
  actions: {},
  getters: {
    getLeaveDetail(state) {
      return state.detail
    },
    getLeavePageQuery(state) {
      return state.urlQuery
    },
    getLeaveList(state) {
      return {
        list: state.selectedLeaveList,
        index: state.leaveQueueIndex
      }
    }
  }
}
